var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7071 16.3438C33.0976 15.9533 33.0976 15.3201 32.7071 14.9296C32.3166 14.5391 31.6834 14.5391 31.2929 14.9296L25.348 20.8745L21.0734 15.0454C20.885 14.7885 20.5856 14.6367 20.267 14.6367H16C15.6232 14.6367 15.2783 14.8486 15.108 15.1847C14.9377 15.5208 14.9708 15.9242 15.1936 16.2281L21.4554 24.7671L15.2929 30.9296C14.9024 31.3201 14.9024 31.9533 15.2929 32.3438C15.6834 32.7343 16.3166 32.7343 16.7071 32.3438L22.652 26.3989L26.9266 32.2281C27.115 32.4849 27.4145 32.6367 27.733 32.6367H32C32.3768 32.6367 32.7217 32.4249 32.892 32.0887C33.0623 31.7526 33.0293 31.3492 32.8064 31.0453L26.5446 22.5063L32.7071 16.3438ZM24.3703 22.9232C24.4012 22.9747 24.4371 23.0239 24.4781 23.0703L30.0266 30.6367H28.2398L17.9734 16.6367H19.7603L24.3703 22.9232Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.2b6ff259d7abaf98f0981ae1aad4b16c.svg";
export { ForwardRef as ReactComponent };